import { PromotionFormData } from '@src/types/promotion';
import {
  PromotionListParams,
  PromotionParams,
  PromotionStatusType,
} from './promotions';
import { oliveApi } from '../index';

const url = `/admin/v1/promotions`;

const createPromotionApi = async (data: PromotionFormData) => {
  return await oliveApi.POST(url, data);
};

const getPromotionListApi = async (params: PromotionListParams) => {
  return await oliveApi.GET<PromotionListParams, any>(url, params);
};

const getPromotionApi = async (id: number) => {
  return await oliveApi.GET<number, any>(`${url}/${id}`);
};

const updatePromotionApi = async (id: number, params: PromotionFormData) => {
  return await oliveApi.PATCH<PromotionFormData, any>(`${url}/${id}`, params);
};

const updatePromotionStatusApi = async (
  id: number,
  status: PromotionStatusType
) => {
  return await oliveApi.PATCH<PromotionParams, any>(`${url}/${id}/${status}`);
};

const deletePromotionApi = async (id: number) => {
  return await oliveApi.DELETE<number, any>(`${url}/${id}`);
};

export {
  createPromotionApi,
  getPromotionListApi,
  getPromotionApi,
  updatePromotionApi,
  updatePromotionStatusApi,
  deletePromotionApi,
};
